<div class="added-user-card" [class.added-user-card--error]="user.hasError">
  @if (user.hasError && user.errorMessage) {
    <div class="added-user-card__error-badge">
      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0ZM6.6 9H5.4V7.8H6.6V9ZM6.6 6.6H5.4V3H6.6V6.6Z" fill="currentColor"/>
      </svg>
      <span>{{ user.errorMessage }}</span>
    </div>
  }

  <div class="added-user-card__info">
    <div class="added-user-card__row">
      <span class="added-user-card__field-label">{{ 'charity_profile.users.invite-user.first-name-short' | translateLang }} :</span>
      <span class="added-user-card__field-value">{{ user.firstName }}</span>
    </div>
    <div class="added-user-card__row">
      <span class="added-user-card__field-label">{{ 'charity_profile.users.invite-user.last-name-short' | translateLang }} :</span>
      <span class="added-user-card__field-value">{{ user.lastName }}</span>
    </div>
    <div class="added-user-card__row">
      <span class="added-user-card__field-label">{{ 'charity_profile.users.invite-user.email-short' | translateLang }} :</span>
      <span class="added-user-card__field-value added-user-card__field-value--wide">{{ user.email }}</span>
    </div>
    <div class="added-user-card__row">
      <span class="added-user-card__field-label">{{ 'charity_profile.users.invite-user.no-of-charity' | translateLang }} :</span>
      <span class="added-user-card__field-value">{{ user.charities?.length ?? 0 }}</span>
    </div>

    <div class="added-user-card__row">
      <span class="added-user-card__field-label">{{ 'charity_profile.users.invite-user.type-role' | translateLang }} :</span>
      <span class="added-user-card__field-value added-user-card__field-value--wide">{{ user.userTypeLabel }} - {{ user.roleLabel }}</span>
    </div>

    @if (user.charities && user.charities.length > 0) {
      <div class="added-user-card__row added-user-card__row--charity">
        <span class="added-user-card__field-label added-user-card__field-label--charity">{{ 'charity_profile.users.invite-user.charity-short' | translateLang }} :</span>
        <div class="added-user-card__charity-list">
          @for (entry of user.charities; track entry.charity.uuid) {
            <div class="added-user-card__charity-entry">
              <div class="added-user-card__charity-org">
                <span class="added-user-card__charity-org-label">{{ 'settings.users.mobile.organization' | translateLang }} :</span>
                <span class="added-user-card__field-value added-user-card__charity-name">{{ entry.charity.name }}</span>
              </div>
              <div class="added-user-card__charity-role">
                <span class="added-user-card__role-label added-user-card__role-label--desktop">{{ 'charity_profile.users.invite-user.role-short' | translateLang }} :</span>
                <span class="added-user-card__role-label added-user-card__role-label--mobile">{{ 'charity_profile.users.invite-user.type-role' | translateLang }} :</span>
                <span class="added-user-card__field-value">{{ entry.roleLabel }}</span>
              </div>
            </div>
          }
        </div>
      </div>
    }
  </div>

  <div class="added-user-card__actions">
    <button
      class="added-user-card__icon-button added-user-card__icon-button--edit"
      (click)="onEdit()"
      type="button"
      [disabled]="disabled"
      aria-label="Edit user"
    >
      <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.70825 3.16675H3.16659C2.72656 3.16675 2.30461 3.34174 1.99205 3.6543C1.67948 3.96687 1.50449 4.38882 1.50449 4.82884V15.8334C1.50449 16.2735 1.67948 16.6954 1.99205 17.008C2.30461 17.3206 2.72656 17.4956 3.16659 17.4956H14.1711C14.6112 17.4956 15.0331 17.3206 15.3457 17.008C15.6583 16.6954 15.8333 16.2735 15.8333 15.8334V10.2918" stroke="currentColor" stroke-width="1.58333" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M14.5625 1.89575C14.8916 1.56668 15.3374 1.38184 15.8021 1.38184C16.2667 1.38184 16.7125 1.56668 17.0417 1.89575C17.3707 2.22483 17.5556 2.67063 17.5556 3.13529C17.5556 3.59995 17.3707 4.04574 17.0417 4.37482L9.53906 11.8775L6.32031 12.7085L7.15136 9.48971L14.5625 1.89575Z" stroke="currentColor" stroke-width="1.58333" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>
    <button
      class="added-user-card__icon-button added-user-card__icon-button--delete"
      (click)="onDelete()"
      type="button"
      [disabled]="disabled"
      aria-label="Delete user"
    >
      <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1.5 3H2.54762H10.5" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M4.11914 3V1.95238C4.11914 1.69944 4.21962 1.45678 4.39894 1.27746C4.57826 1.09814 4.82092 0.997656 5.07386 0.997656H6.93672C7.18966 0.997656 7.43232 1.09814 7.61164 1.27746C7.79096 1.45678 7.89144 1.69944 7.89144 1.95238V3M9.46191 3V10.0476C9.46191 10.3006 9.36143 10.5432 9.18211 10.7225C9.00279 10.9019 8.76013 11.0024 8.50719 11.0024H3.50291C3.24997 11.0024 3.00731 10.9019 2.82799 10.7225C2.64867 10.5432 2.54819 10.3006 2.54819 10.0476V3H9.46191Z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M5.07227 5.33594V8.57689" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M6.92969 5.33594V8.57689" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>
  </div>
</div>
